<template>

  <Modal modalClass="Contact__modal">

    <template v-slot:title>Nous<br/><strong>contacter</strong></template>

    <div class="Contact__aside">
      <div class="inner">
        <h3>Contacter notre équipe Relation Client</h3>
        <p>Nos experts sont à votre écoute pour vous informer, vous conseiller et vous accompagner, <strong>du lundi au jeudi de 9h00 à 18h00 et le vendredi jusqu’à 17h00</strong>.</p>
        <ExternalButtonLink href="tel:0170991500" class="is--min">
          01 70 99 15 00 <i>(appel non surtaxé)</i>
        </ExternalButtonLink>
      </div>

      <div class="inner">
        <h3>Prendre un rendez-vous avec notre équipe commerciale</h3>
        <p>Dans nos locaux ou en visio-conférence, n'hésitez pas à prendre rendez-vous avec notre équipe commerciale afin de <strong>trouver les réponses à vos questions</strong>.</p>
        <ExternalButtonLink href="tel:0170991500" class="is--min">
          01 73 02 42 70 <i>(appel non surtaxé)</i>
        </ExternalButtonLink>
      </div>
    </div>

    <form :action="route('contact.form.post')" method="post" @submit.prevent="submit" class="Form">
      <fieldset>
        <div class="row">
          <div class="Radios__container is--full">
            <div class="Form__group">
              <label>Préférence de moyen de contact</label>
              <div class="Radios">
                <Radio
                    v-for="(label, value) in $page.props.forms.contact.contact_methods"
                    v-model="form.contact_method"
                    name="contact_method"
                    :key="value"
                    :settings="{label, value}"
                    required="true"
                />
                <span v-for="error in $page.props.errors.contact_method" class="error">{{ error }}</span>
              </div>
            </div>
          </div>
          <Input
              label="Nom"
              type="text"
              max="191"
              name="lastname"
              id="lastname"
              v-model="form.name"
              required="true"
              :error="$page.props.errors.name"
          />
          <Input
              label="Prénom"
              type="text"
              max="191"
              name="firstname"
              id="firstname"
              v-model="form.firstname"
              required="true"
              :error="$page.props.errors.firstname"
          />
          <Input
              label="Email"
              type="email"
              max="191"
              name="email"
              id="email"
              v-model="form.email"
              :required="form.contact_method === 'email'"
              class="is--full"
              :error="$page.props.errors.email"
          />

          <div class="Phone__container is--full">
            <Phone
                label="Téléphone de la personne à contacter"
                v-model:phone="form.phone"
                v-model:identifier="form.identifier"
                :error-phone="form.errors.phone"
                :error-identifier="form.errors.identifier"
                :required="form.contact_method === 'tel'"
                name="phone"
            />
          </div>

        </div>
      </fieldset>
      <fieldset>
        <div class="row">
          <Input
              label="Société/Cabinet"
              type="text"
              max="191"
              name="office"
              v-model="form.office"
              id="office"
              :error="$page.props.errors.office"
          />

          <Input
              label="Référence KERIALIS"
              type="text"
              max="191"
              name="matricule"
              v-model="form.matricule"
              id="matricule"
              :error="$page.props.errors.matricule"
          />

          <div class="Form__group is--full">
            <Select
                label="Fonction"
                name="fonction"
                id="fonction"
                v-model="form.fonction"
                :options="fonctions"
                required="true"
                :error="$page.props.errors.fonction"
            />
          </div>

          <div class="Form__group is--full">
            <Select
                name="subject"
                id="subject"
                v-model="form.subject"
                label="Sujet"
                :options="subjects"
                required="true"
                :error="$page.props.errors.subjects"
            />
          </div>

          <Textarea
              label="Votre message"
              name="subject"
              id="subject"
              maxLength="1000"
              v-model="form.message"
              required="true"
              class="is--full"
              :error="$page.props.errors.message"
          />
        </div>
        <p class="disclaimer">KERIALIS en sa qualité de responsable de traitement met en œuvre des traitements de données à caractère personnel ayant pour finalité la gestion de votre dossier. Vous disposez d’un droit d’accès, d’opposition, d’interrogation, de rectification, d’effacement, de portabilité, de limitation du traitement des données à caractère personnel vous concernant. Vous pouvez exercer ces droits par l’envoi d’un courrier simple à KERIALIS Prévoyance, RGPD – 80 rue Saint-Lazare-75009 Paris ou par e-mail à rgpd@kerialis.fr. Vous disposez par ailleurs, du droit d’introduire une réclamation auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL), notamment sur son site internet www.cnil.fr.</p>
      </fieldset>
      <div class="Form__actions">
        <Button type="submit" class="is--green is--center" :disabled="form.processing">Valider</Button>
      </div>
    </form>
  </Modal>

</template>

<script>
import Modal from '@components/Modal'
import Icon from '@components/Icon'
import Select from '@components/form/Select'
import Input from "@components/form/Input";
import ToolTip from "@components/ToolTip";
import Checkbox from "@components/form/Checkbox";
import Radio from "@components/form/Radio";
import { Inertia } from '@inertiajs/inertia'
import Textarea from "@components/form/Textarea";
import {useForm} from "@inertiajs/inertia-vue3";
import {useNotifs} from "@/store/notifs";
import Button from "@components/navigation/Button";
import ExternalButtonLink from "@components/navigation/ExternalButtonLink";
import Phone from "@components/form/Phone";

export default {
  components: {Phone, Textarea, Modal, Icon, Select, Button, Input, Checkbox, ToolTip, Radio, ExternalButtonLink },
  setup() {

    const sliderSettings = { value: 6, min: 1, max: 10, step: 1 }

    const currentUser = Inertia.page.props.current_user;
    let currentOffice = Inertia.page.props.current_office;

    const formConfig = Inertia.page.props.forms.contact;

    let form = useForm({
      firstname: currentUser?.firstname,
      name: currentUser?.name,
      email: currentUser?.email,
      identifier: null,
      phone: null,
      contact_method: null,
      office: currentOffice?.name,
      matricule: currentOffice?.matricule,
      subject: null,
      fonction: null,
      message: null
    })

    Inertia.on('success', () => {
      currentOffice = Inertia.page.props.current_office;
      form.office= currentOffice?.name;
      form.matricule= currentOffice?.matricule;
    })

    const fonctions = formConfig.fonctions.map((value) => ({
      value, label:value
    }));

    const subjects = formConfig.subjects.map((value) => ({
      value, label:value
    }));

    return {
      sliderSettings,
      fonctions,
      subjects,
      form,
    }
  },
  methods: {
    submit() {
      this.form.clearErrors()

      this.form.post(route('contact.form.post'), {
        onSuccess: () => {
          this.$modal.hideAll()
          this.form.reset()
          useNotifs.push({
            id : new Date().getTime(),
            icon : 'check',
            state : 'success',
            title : `Demande de contact`,
            text: "Votre message a bien été envoyé. Nous reviendrons vers vous prochainement. L’équipe KERIALIS."
          })
        },
      });
    }
  }
}
</script>

<style lang="scss">
  @import "~@sass/components/contact/_ContactModal.scss";
</style>
